import { useState, useEffect } from 'react';
import { useWatch } from 'react-hook-form';

export interface WizardStateInterface {
  // Whether the wizard has been displayed to the user already in this session
  wizardHasBeenDisplayed: boolean;
  setWizardHasBeenDisplayed: (enable: boolean) => void;

  // Whether the wizard is visible to the user
  isWizardOpen: boolean;
  setWizardOpen: (enable: boolean) => void;

  // Whether the header buttons should be displayed
  showHeaderButtons: boolean;

  // Whether the review and template meet the criteria to show the wizard and
  // we should force the user to use it.
  // * The template must not have been published
  // * The wizard has not already been displayed in this session
  shouldForceWizardUse: boolean;
}

export const useWizardState = (): WizardStateInterface => {
  const [wizardHasBeenDisplayed, setWizardHasBeenDisplayed] = useState(false);
  const [shouldForceWizardUse, setShouldForceWizardUse] = useState(true);
  const [isWizardOpen, setWizardOpen] = useState(false);
  const watchUpdateBy = useWatch({ name: 'updated_by' });

  useEffect(() => {
    // If the updateBy has been set on the template, then the template has been published
    const templateUnpublished = !watchUpdateBy;

    setShouldForceWizardUse(templateUnpublished && !wizardHasBeenDisplayed);
  }, [watchUpdateBy, wizardHasBeenDisplayed, setShouldForceWizardUse]);

  const showHeaderButtons =
    (wizardHasBeenDisplayed || !shouldForceWizardUse) && !isWizardOpen;

  return {
    wizardHasBeenDisplayed,
    setWizardHasBeenDisplayed,
    shouldForceWizardUse,
    isWizardOpen,
    setWizardOpen,
    showHeaderButtons,
  };
};
